import { FC, useEffect } from "react";
import {
    Text,
    Heading,
    Container,
    Flex,
    Picture,
    Box,
    Button,
} from "@smile2impress/components/relaunch";
import { sanitizeHtml } from "@smile2impress/attraction-utils";

import { SentryErrorType } from "constants/enum";
import { ErrorPageProps } from "content/error/types";
import { reportToSentry } from "utils/reportToSentry";
import { AnalyticsIdElement } from "constants/analytics";
import Link from "components/Link";

import { ErrorType } from "../../ErrorLayout.types";

export const ErrorNotFound: FC<ErrorPageProps> = ({
    errorCode,
    title,
    subtitle,
    image,
    button,
    errorType = ErrorType.NOT_FOUND,
}) => {
    useEffect(() => {
        switch (errorType) {
            case ErrorType.NOT_FOUND: {
                reportToSentry({
                    error: SentryErrorType.PAGE_NOT_FOUND,
                    level: "error",
                });
                break;
            }
            case ErrorType.REFERRAL: {
                reportToSentry({
                    error: SentryErrorType.WRONG_REFERRAL_LINK,
                    level: "warning",
                });
                break;
            }
        }
    }, []);

    return (
        <Container id={AnalyticsIdElement.NOT_FOUND}>
            <Flex
                px={[0, 0, 4]}
                flexDirection={["column-reverse", "column-reverse", "row"]}
                justifyContent="space-between"
                columnGap={[0, 0, 5.5]}
                rowGap={[3, 3, 0]}
            >
                <Flex direction="column" flex="1" alignItems="start">
                    <Heading mb={[0.5]} textStyle="H1" color="text.primary">
                        {errorCode}
                    </Heading>
                    <Heading mb={[2]} textStyle="H1">
                        {title}
                    </Heading>
                    <Text
                        mb={[2, 2, 3]}
                        textStyle="body"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(subtitle),
                        }}
                    />
                    {button && (
                        <Button size="md" as={Link} href={button.link}>
                            {button.text}&nbsp;→
                        </Button>
                    )}
                </Flex>
                <Flex flex="1">
                    <Box overflow="hidden" borderRadius="sm">
                        {image && <Picture {...image} />}
                    </Box>
                </Flex>
            </Flex>
        </Container>
    );
};
